export default "__VITE_ASSET__e98a3311__"